import React, { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { viewState } from '@internal/window/atom'
import { viewTypeSelector } from '@internal/window/selectors'
import TerminalOutput from '@components/terminal-output';
import TerminalInput from '@components/terminal-input';
import Mobile from "./mobile";

import './main.scss'

type MainProps = {}

function getWindowDimensions() {
  const { outerWidth: width, outerHeight: height } = window;
  return {
    width,
    height
  };
}

// https://www.asciiart.eu/text-to-ascii-art
// calvin lee

const Main = ({}: MainProps): JSX.Element => {
  const setWindowDimensions = useSetRecoilState(viewState)
  const viewType = useRecoilValue(viewTypeSelector);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // My laptop screen is H: 965 x W: 1680
  // Most likely I'll want something smaller for the boarder

  return (
    <>
      <div className="main-container">
        <main className="main-body">
          <div className="view-container">
            <TerminalOutput />
            <TerminalInput />
          </div>
        </main>
        <div className="main-spacer"></div>
      </div>
      <div className="mobile-container">
        <main className="mobile-body">
          <Mobile />
        </main>
      </div>
    </>
  );
};

export default Main;